import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withAuth } from '../providers/AuthProvider';

class Navbar extends Component {
	render() {
		const { isLoggedIn, logout } = this.props;
		return (
			<div>
				{isLoggedIn ? (
					<div className="text-center pt-5 main">
						<button className="text-blue-600 mr-10" ><Link to="/">Home</Link></button>
						<button  className="text-blue-600" onClick={logout}>Logout</button>
					</div>
				) : ""}
			</div>
		);
	}
}

export default withAuth(Navbar);
